import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Image } from '@hivebrite/design-system/Image';

import { useMentorshipsContext } from 'hb-react/frontoffice/apps/Mentorships/contexts/MentorshipsContext';
import { getUserLocation } from 'hb-react/frontoffice/apps/Mentorships/utils';
import ErrorFocus from 'hb-react/shared/components/formik/components/ErrorFocus';
import {
  Hidden,
  Textarea,
} from 'hb-react/shared/components/formik/components/inputs';
import RequiredExplanation from 'hb-react/shared/components/formik/components/RequiredExplanation';
import { completeName } from 'helpers/name';

const ApplyToBeMenteeForm = ({ onSubmit, onCancel, mentor }) => {
  const { menteeApplicationFormText } = useMentorshipsContext();

  const user = mentor.user || {};
  const location = getUserLocation(user);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box flexDirection="column" width="100%">
      <Box alignItems="center" mb={3}>
        <AvatarWrapper>
          <Image src={user.photo_thumb_url} alt={user.completeName} />
        </AvatarWrapper>
        <Box flexDirection="column" ml={5}>
          <Box as="h4" font="h4-regular">
            {completeName(user)}
          </Box>
          {location && <Box font="body-regular-dove">{location}</Box>}
        </Box>
      </Box>

      <CustomMessageBox
        dangerouslySetInnerHTML={{
          __html: menteeApplicationFormText,
        }}
      />

      <Formik
        initialValues={{ relationship: { mentor_id: mentor.id } }}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form>
            <ErrorFocus />
            <Hidden name="relationship[mentor_id]" />
            <RequiredExplanation />
            <Textarea
              label={s__('Mentorships|Message')}
              name="relationship[request_message]"
              validate={{ required: true }}
              minHeight={180}
            />
            <Box justifyContent="flex-end" mt={6}>
              {onCancel && (
                <Box mr={4}>
                  <Button onClick={onCancel} variant="secondary">
                    {__('Cancel')}
                  </Button>
                </Box>
              )}
              <Button isDisabled={formik.isSubmitting} type="submit">
                {__('Submit')}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

ApplyToBeMenteeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  mentor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.shape({
      photo_thumb_url: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default ApplyToBeMenteeForm;

const AvatarWrapper = styled(Box).attrs(() => ({
  width: 60,
  height: 60,
}))`
  border-radius: 50%;

  img {
    border-radius: 50%;
    width: inherit;
  }
`;

// Attempt at making the spacing consistent accross the dialog
// despite user-defined content.
const CustomMessageBox = styled(Box)`
  flex-direction: column;

  > p {
    margin-bottom: 12px;
  }
`;
